(function() {
  'use strict';

  angular
    .module('boxPreview')
    .factory('boxPreviewErrorService', errorService);

  errorService.$inject = ['$modal', 'Navigation', 'SpinnerHelper'];

  function errorService($modal, Navigation, SpinnerHelper) {
    var instance;

    return {
      showError: showError
    };

    function showError(scope) {
      // only 1 error at a time
      if (instance) {
        scope.$destroy();
        return;
      }

      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();

      instance = $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: scope,
        backdrop: 'static'
      });

      scope.$on('$destroy', function() {
        instance = null;
      });
    }
  }
})();
